import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { DialogContent } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { ScenarioDecision } from "@/consts/Scenario";
import { zodResolver } from "@hookform/resolvers/zod";
import { AlertDialog } from "@radix-ui/react-alert-dialog";
import { useState } from "react";

type Props = {
  type: ScenarioDecision.APPROVED | ScenarioDecision.REJECTED;
  open: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
};

const APPROVAL_LABELS = {
  [ScenarioDecision.APPROVED]: {
    title: "승인 확정",
    label: "승인 사유",
    description: "해당 시나리오를 승인하시겠습니까?",
  },
  [ScenarioDecision.REJECTED]: {
    title: "반려 확정",
    label: "반려 사유",
    description: "해당 시나리오를 반려하시겠습니까?",
  },
};

export default function ApprovalAlertDialog({
  type,
  open,
  onClose,
  onSubmit,
}: Props) {
  const [reason, setReason] = useState<string>("");

  if (!type) return null;

  const { title, label, description } = APPROVAL_LABELS[type];

  const handleConfirm = () => {
    onSubmit(reason);
    setReason("");
  };

  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <AlertDialogContent className="w-[639px] h-[457px] flex flex-col gap-4">
        <AlertDialogHeader className="flex flex-col gap-4">
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-col flex-1 gap-2">
          <p className="text-sm text-gray-A font-semibold">{label}</p>
          <Textarea
            className="flex-1 resize-none"
            placeholder="사유를 입력해주세요"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel className="h-8 py-2 px-5 border border-gray-D bg-gray-E hover:bg-gray-E rounded-md text-sm text-gray-A font-semibold">
            취소하기
          </AlertDialogCancel>
          <AlertDialogAction
            className="h-8 py-2 px-5 border border-dark-red bg-dark-red hover:bg-dark-red rounded-md text-sm text-white font-semibold"
            onClick={handleConfirm}
          >
            확정하기
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
